
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import CountDown from '@/components/vue2-countdown'
import config from '@/config'
import { getUserAccount } from '@/api/user.js'
import { getActivityDetail, getJoin } from '@/api/youzheng.js'
import success from '@/assets/success.png'
import fail from '@/assets/fail.png'
export default {
name: 'bulk',
components: {
Group,
Cell,
CountDown,
Swiper,
XButton
},
data () {
return {
baseUrl: config.baseUrl,
currentTime: '',
picList: [],
productObj: {},
currentTime: '',
signenddate: '',
signstartdate: '',
success: success,
fail: fail
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
methods: {
getdetail () {
getActivityDetail({
id: this.$route.params.id,
accountid: this.accountid
}).then(res => {
this.productObj = res.returnValue
let imgList = []
res.returnValue.picsList.forEach((item, i) => {
imgList.push(this.baseUrl + item.FILEPATH)
})
this.picList = imgList.map((one, index) => ({
url: 'javascript:',
img: one
}))
this.$set(this.productObj, "signstartdate", new Date(res.returnValue.signstartdate.replace(/-/g, '/')).getTime())
this.$set(this.productObj, "signenddate", new Date(res.returnValue.signenddate.replace(/-/g, '/')).getTime())
})
},
countDownS_cb: function (x) {
},
countDownE_cb: function (x) {
},
joinGroup () {
if (this.productObj.grouplimit != 0 && this.productObj.joinnum >= this.productObj.grouplimit) {
this.$vux.alert.show({
title: '提示',
content: '该团购已到达上限人数，无法参团',
onShow () {
},
onHide () {
}
})
} else {
getJoin({
groupid: this.productObj.id,
accountid: this.accountid
}).then(res => {
var _this = this
this.$vux.alert.show({
title: '提示',
content: res.message,
onShow () {
},
onHide () {

_this.$router.push({ name: 'tuanGouList' })
}
})
})
}
},
},
created () {
this.getdetail()
},
mounted () {
setInterval(() => {
var timestamp = (new Date()).getTime()
this.currentTime = timestamp
}, 1000)
}
}
